import { Component } from "react";
import { connect, ConnectedComponent } from "react-redux";
import { Image } from "../../../../Common/Image";
import { IConfirmationStepInfo, IStore } from "../../../DataTypes/storeTypes";
import { IClient } from "../../../DataTypes/clientTypes";
import { selectClient } from "../../../Actions/clientActions";
import { applyClientDiscount, applyTax, tryToApplyDeposit } from "../../../Actions/serviceActions";

import { CustomSelect } from "common.ui/Components/customReactSelect/customSelect";

import { showStripe } from "../../../Actions/confirmationActions";

interface IProps {
    cdnHost: string;
    clients: IClient[];
    loggedInClientId: number;
    selectedClientId?: number;
    appointmentBooked: boolean;
    select(id: number): void;
}

class AppointmentClient extends Component<IProps> {
    render() {
        const selectOptions = this.props.clients.map((c) => {
            return {
                value: c.id.toString(),
                label: c.name,
            };
        });

        const selected = selectOptions.find((o) => o.value == this.props.selectedClientId.toString());

        return (
            <div className="summary-item clients">
                <div className="summary-icon">
                    <Image src={`${this.props.cdnHost}/images/confirmation/provider.svg`} width="24" height="24" />
                </div>
                <div className="summary-text">
                    <label className="text-uppercase">Appointment for:</label>
                    {this.props.appointmentBooked ? (
                        <div>
                            <a>{selected.label}</a>
                        </div>
                    ) : (
                        <div className="form-group">
                            <CustomSelect
                                value={selected}
                                options={selectOptions}
                                onChange={(selected) => this.props.select(+(selected as any).value)}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IStore, ownProps: IProps): IProps => {
    const info = state.stepsInfo[state.common.currentStep] as IConfirmationStepInfo;

    return {
        ...ownProps,
        cdnHost: state.initialSettings.cdnHost,
        clients: [...state.common.clients],
        appointmentBooked: !!state.common.bookedAppointment,
        selectedClientId: info.clientId,
    };
};

const mapDispatchToProps = (dispatch, ownProps: IProps): IProps => {
    return {
        ...ownProps,
        select: (id: number) => {
            dispatch(selectClient(id));
            dispatch(applyClientDiscount(id));
            dispatch(tryToApplyDeposit());
            dispatch(applyTax());
            dispatch(showStripe(false));
        },
    };
};

export const AppointmentClientConnected: ConnectedComponent<typeof AppointmentClient, any> = connect(
    mapStateToProps,
    mapDispatchToProps
)(AppointmentClient);
